import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import {
  ImageModel,
  IStoreImagesStateError,
  IStoreImagesStateSuccess,
  StoreImagesStateType,
} from '@boxx/store-core';
import { ActionReducer, createReducer, on } from '@ngrx/store';
import * as fromImagesActions from './store-images.action';

export interface IStoreImagesState
  extends BoxxGenericState<
    ImageModel[],
    IStoreImagesStateSuccess,
    IStoreImagesStateError
  > {
  selectedImage: ImageModel;
}

export const imagesInitialState: IStoreImagesState = {
  ...getGenericInitialState(),
  data: [],
  selectedImage: null,
};

export const storeImagesReducer: ActionReducer<IStoreImagesState> =
  createReducer(
    imagesInitialState,
    on(
      fromImagesActions.loadImagesBeginAction,
      fromImagesActions.loadImageByIdBeginAction,
      fromImagesActions.createImageBeginAction,
      fromImagesActions.deleteImageBeginAction,
      (state, action): IStoreImagesState => ({
        ...state,
        isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromImagesActions.loadImagesSuccessAction,
      fromImagesActions.createImageSuccessAction,
      fromImagesActions.deleteImageSuccessAction,
      (state, action): IStoreImagesState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: { after: getStoreImagesActionType(action.type) },
      })
    ),
    on(
      fromImagesActions.loadImageByIdSuccessAction,
      (state, action): IStoreImagesState => ({
        ...state,
        isLoading: false,
        selectedImage: action.payload,
        error: null,
        success: { after: getStoreImagesActionType(action.type) },
      })
    ),
    on(
      fromImagesActions.loadImagesFailAction,
      fromImagesActions.loadImageByIdFailAction,
      fromImagesActions.createImageFailAction,
      fromImagesActions.deleteImageFailAction,
      (state, action): IStoreImagesState => ({
        ...state,
        isLoading: false,
        error: {
          after: getStoreImagesActionType(action.type),
          error: action.errors,
        },
        success: null,
      })
    ),
    on(fromImagesActions.clearImagesSuccessErrorDataAction, (state) => ({
      ...state,
      error: null,
      success: null,
    }))
  );

const getStoreImagesActionType = (
  type: fromImagesActions.StoreImagesActionTypes
) => {
  let action: StoreImagesStateType;

  switch (type) {
    case fromImagesActions.StoreImagesActionTypes.loadImagesSuccess:
    case fromImagesActions.StoreImagesActionTypes.loadImagesFail:
    case fromImagesActions.StoreImagesActionTypes.loadImageByIdSuccess:
    case fromImagesActions.StoreImagesActionTypes.loadImageByIdFail:
      action = 'LOAD_IMAGES';
      break;
    case fromImagesActions.StoreImagesActionTypes.createImageBegin:
    case fromImagesActions.StoreImagesActionTypes.createImageFail:
      action = 'CREATE_IMAGE';
      break;
    case fromImagesActions.StoreImagesActionTypes.delteImageSuccess:
    case fromImagesActions.StoreImagesActionTypes.delteImageFail:
      action = 'DELETE_IMAGE';
      break;
    default:
      action = 'UNKNOWN';
  }

  return action;
};
